module.exports = __webpack_public_path__ + "img/1522208195.e8312506.jpg";